<div class="modal fade" id="organizationContactFormModal" msEscClose
  (escPressed)="onCancel()"
  data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="organizationContactFormModalLabel">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border-0 p-4">
        <h5 class="modal-title mb-0" id="organizationContactFormModalLabel">
          @if (!selectedType()) {
            Add / Edit Contact
          } @else if (selectedContact()) {
            Edit {{ selectedType() }} Contact
          } @else {
            Add {{ selectedType() }} Contact
          }
        </h5>
      </div>
      <div class="modal-body">
        @if (!selectedType()) {
          <p class="text-muted mb-3">Select a contact type to add or edit.</p>

          <div class="contact-type-options">
            <button type="button"
              class="card mb-2 cursor-pointer contact-type-option w-100 text-start border bg-transparent p-0"
              (click)="selectType(OrganizationContactType.General)">
              <div class="card-body d-flex justify-content-between align-items-center py-2">
                <div class="d-flex align-items-center">
                  <fa-duotone-icon icon="mailbox" secondaryOpacity="0.5" class="fs-4 me-3 text-primary"></fa-duotone-icon>
                  <div>
                    <div class="fw-semibold">General</div>
                    @if (hasContactOfType(OrganizationContactType.General)) {
                      <small class="text-muted">Edit {{ contactNameForType(OrganizationContactType.General) }}</small>
                    } @else {
                      <small class="text-muted">Primary contact for the organization.</small>
                    }
                  </div>
                </div>
                <fa-duotone-icon icon="chevron-right" secondaryOpacity="0.9" class="text-muted"></fa-duotone-icon>
              </div>
            </button>

            <button type="button"
              class="card mb-0 cursor-pointer contact-type-option w-100 text-start border bg-transparent p-0"
              (click)="selectType(OrganizationContactType.Billing)">
              <div class="card-body d-flex justify-content-between align-items-center py-2">
                <div class="d-flex align-items-center">
                  <fa-duotone-icon icon="file-invoice-dollar" secondaryOpacity="0.5" class="fs-4 me-3 text-primary"></fa-duotone-icon>
                  <div>
                    <div class="fw-semibold">Billing</div>
                    @if (hasContactOfType(OrganizationContactType.Billing)) {
                      <small class="text-muted">Edit {{ contactNameForType(OrganizationContactType.Billing) }}</small>
                    } @else {
                      <small class="text-muted">Contact for billing and invoicing matters.</small>
                    }
                  </div>
                </div>
                <fa-duotone-icon icon="chevron-right" secondaryOpacity="0.9" class="text-muted"></fa-duotone-icon>
              </div>
            </button>
          </div>
        } @else {
          <ms-organization-contact-form
            [contactType]="selectedType()!"
            [existingContact]="selectedContact()"
            (cancelRequested)="onCancel()"
            (backRequested)="backToTypeSelection()"
            (submitted)="onContactSubmitted($event)">
          </ms-organization-contact-form>
        }
      </div>
      @if (!selectedType()) {
        <div class="modal-footer border-0 d-flex justify-content-center pb-4">
          <button type="button" class="btn btn-ms-secondary" (click)="onCancel()">
            Cancel
          </button>
        </div>
      }
    </div>
  </div>
</div>

<ms-confirmation-modal
  #contactSaveConfirmationModalRef
  modalId="organizationContactSaveConfirmationModal"
  confirmButtonText="Save"
  cancelButtonText="Cancel"
  (confirmed)="editConfirmationModalConfirmed()"
  (cancelled)="editConfirmationModalCancelled()"
/>

<ms-confirmation-modal
  #contactLeaveConfirmationModalRef
  modalId="organizationContactLeaveConfirmationModal"
  confirmButtonText="Leave"
  cancelButtonText="Stay"
  (confirmed)="onLeaveConfirmed()"
  (cancelled)="onLeaveCancelled()"
/>
